import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, provisioningPath } from '@/lib/api-client';
import { adaptPlaybooks, type ApiPlaybook } from '@/lib/fleet-adapters';
import type { Playbook } from '@/types/provisioning';

import { provisioningKeys } from './provisioning-keys';

/**
 * GET /api/admin/provisioning/playbooks — the full playbook catalogue with
 * each template's survey schema. Cached for 5 minutes: the registry mirrors a
 * static YAML file and changes rarely.
 */
export function useProvisioningPlaybooks(): UseQueryResult<Playbook[], Error> {
  return useQuery({
    queryKey: provisioningKeys.playbooks(),
    queryFn: async ({ signal }) =>
      adaptPlaybooks(await apiClient.get<ApiPlaybook[]>(provisioningPath('/playbooks'), signal)),
    staleTime: 5 * 60_000,
  });
}
